/*

utility that takes an array of objects like
[{ field: 'isDefaultLocation', value: 'true' }]

 and applies your formatter map so the value gets replaced.
 
 const formatter = {
  isDefaultLocation: value => (value === 'true' ? 'Yes' : 'No'),

  will return 
  [{ field: 'isDefaultLocation', value: 'Yes' }]
  
  Used to format Search values displayed in Format List
};
*/

async function formListValueFormatter({ data, formatterMap }) {
  return Promise.all(
    data.map(async ({ field, value }) => ({
      field,
      value: formatterMap[field] ? await formatterMap[field](value) : value,
    })),
  );
}

export default formListValueFormatter;
